import {
  EMAIL_SCHEMA,
  moduleNamespace,
  NAME_SCHEMA,
  PASSWORD_SCHEMA,
  SET_PACKAGE_PRICE_FROM_RESPONSE,
  SET_CONFIGURATION,
  SET_EMAIL,
  SET_ERRORS,
  SET_LAYOUT,
  SET_NAME,
  SET_OPERATION_COUNTRY,
  SET_ORGANISATION_ID,
  SET_PASSWORD,
  SET_STAGE,
  SET_STRIPE_PAYMENT_METHOD_ID
} from "./constants";
import {writeSession} from "../sharedGlobal";
import {getOperationCountrySchema, writeConfigurationToSession} from "./methods";

export default {
  [SET_CONFIGURATION](state, payload) {
    state.configuration = payload;
    writeConfigurationToSession(payload);
  },
  [SET_LAYOUT](state, payload) {
    state.layout = payload;
  },
  [SET_NAME](state, payload) {
    delete state.errors.name;
    const { error } = NAME_SCHEMA.validate(payload);

    if (error) {
      state.errors = {
        name: error.details,
        ...state.errors,
      };
    }

    state.name = payload;
    writeSession(moduleNamespace, 'name', payload);
  },
  [SET_EMAIL](state, payload) {
    delete state.errors.email;
    const { error } = EMAIL_SCHEMA.validate(payload);

    if (error) {
      state.errors = {
        email: error.details,
        ...state.errors,
      };
    }

    state.email = payload;
    writeSession(moduleNamespace, 'email', payload);
  },
  [SET_PASSWORD](state, payload) {
    delete state.errors.password;
    const { error } = PASSWORD_SCHEMA.validate(payload);

    if (error) {
      state.errors = {
        password: error.details,
        ...state.errors,
      };
    }

    state.password = payload;
  },
  [SET_OPERATION_COUNTRY](state, payload) {
    const { value, countries } = payload;
    delete state.errors.operationCountry;
    const { error } = getOperationCountrySchema(countries).validate(value);

    if (error) {
      state.errors = {
        operationCountry: error.details,
        ...state.errors,
      };
    }

    state.operationCountry = value;
    writeSession(moduleNamespace, 'operationCountry', value);
  },
  [SET_ERRORS](state, payload) {
    state.errors = payload;
  },
  [SET_STAGE](state, payload) {
    state.stage = payload;
  },
  [SET_PACKAGE_PRICE_FROM_RESPONSE](state, payload) {
    const {
      message,
      currency,
      billing_period: billingPeriod,
      show_tax: showTax,
      full_price: fullPrice,
      discount,
      monthly_comparison: monthlyCostComparison,
      ...data
    } = payload;

    let price = {
      currency,
      billingPeriod,
      showTax,
      fullPrice: {
        exVat: fullPrice.ex_vat,
        incVat: fullPrice.inc_vat,
        exVatDisplay: fullPrice.ex_vat_display,
        incVatDisplay: fullPrice.inc_vat_display,
      },
      monthlyCostComparison,
    };

    if  (discount) {
      price = {
        ...price,
        discount: {
          exVat: discount.ex_vat,
          incVat: discount.inc_vat,
          exVatDisplay: discount.ex_vat_display,
          incVatDisplay: discount.inc_vat_display,
        }
      };

      state.discountMetaData = {
        description: discount.name
      };
    }

    const params = new URLSearchParams(window.location.search);
    if ((params.has('discount') || params.has('d') ) && discount === null) {
      state.discountMetaData = {
        error: "Invalid discount code",
        message: "The supplied coupon is invalid. Please ensure you have copied the correct link. If you are sure the coupon is correct please contact support for further assistance"
      };
    }

    state.price = price;
  },
  [SET_STRIPE_PAYMENT_METHOD_ID](state, payload) {
    state.stripePaymentMethodId = payload;
    writeSession(moduleNamespace, 'stripePaymentMethodId', payload);
  },
  [SET_ORGANISATION_ID](state, payload) {
    state.registrationId = payload;
    writeSession(moduleNamespace, 'registrationId', payload);
  },
};
